import type { AuthState } from "@/data/types/auth";
import { authService } from "@/services/auth/auth-service/auth-service";
import { authStorage } from "@/services/auth/auth-storage/auth-storage";

const UNAUTHENTICATED: AuthState = {
  isAuthenticated: false,
  isLoading: false,
  user: null,
  tokens: null,
  error: null,
};

export const resolveAuthState = async (): Promise<AuthState> => {
  const [tokens, user] = await Promise.all([
    authStorage.getTokens(),
    authStorage.getUser(),
  ]);

  if (!tokens) {
    return UNAUTHENTICATED;
  }

  if (!authStorage.isTokenExpired(tokens)) {
    return {
      isAuthenticated: true,
      isLoading: false,
      user,
      tokens,
      error: null,
    };
  }

  const refreshed = await authService.refreshTokens();

  if (!refreshed) {
    await authStorage.clearAll();
    return {
      ...UNAUTHENTICATED,
      error: "Session expired. Please log in again.",
    };
  }

  const [newTokens, newUser] = await Promise.all([
    authStorage.getTokens(),
    authStorage.getUser(),
  ]);

  return {
    isAuthenticated: true,
    isLoading: false,
    user: newUser,
    tokens: newTokens,
    error: null,
  };
};
